module.exports = __webpack_public_path__ + "img/banner.a63a0104.png";